// Device-local UI preferences (no backend). Persisted to localStorage and applied
// to <html> so they take effect app-wide. Identity (name/email/photo) comes from
// the Google sign-in token and is intentionally NOT stored here — only the
// optional display-name override and pure UI toggles live in this layer.

const KEY = 'pm-prefs';

export const DEFAULT_PREFS = {
  displayName: '',          // optional override for the JWT name
  reducedMotion: false,     // minimise animations/transitions
  sidebarDefault: 'open',   // 'open' | 'collapsed' — dashboard nav at load
};

export function getPrefs() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || '{}');
    return { ...DEFAULT_PREFS, ...(raw && typeof raw === 'object' ? raw : {}) };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function setPrefs(patch) {
  const next = { ...getPrefs(), ...patch };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* noop */ }
  applyPrefs(next);
  return next;
}

// Reflect preferences that have a global visual effect onto <html>. Called on
// every change and once at app start (see App.js).
export function applyPrefs(p = getPrefs()) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-reduced-motion', p.reducedMotion ? 'true' : 'false');
}
